import type {Result, UseCase} from 'framework';
import type {AuthRepository, SignInWithEmailData} from '../ports/auth.repository';
import type {Session} from '../../domain/session';
import type {SignInError} from '../../domain/errors';

export class SignInWithEmail implements UseCase<[SignInWithEmailData], Session> {
  constructor(private readonly authRepository: AuthRepository) {}

  execute(data: SignInWithEmailData): Promise<Result<Session, SignInError>> {
    return this.authRepository.signInWithEmail(data);
  }
}
